module.exports = __webpack_public_path__ + "img/002.e2f99897.jpg";